package com.trevorwiebe.timesheet.admin.loadrate.presentation

import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRate
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateCategory
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateType
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRateUnit

sealed class LoadRateEvent {
    data object OnAddClick : LoadRateEvent()
    data class OnEditClick(val loadRate: LoadRate) : LoadRateEvent()
    data object OnDismissDialog : LoadRateEvent()
    data class OnSave(
        val rateCategory: LoadRateCategory,
        val rateType: LoadRateType,
        val unit: LoadRateUnit?,
        val perUnitText: String,
        val flatRateText: String,
        val pickupLocationId: String,
        val dropLocationId: String,
    ) : LoadRateEvent()
    data class OnSearchQueryChanged(val value: String) : LoadRateEvent()
    data class OnFilterToggled(val category: LoadRateCategory) : LoadRateEvent()
    data object OnErrorShown : LoadRateEvent()
}
